import pythonApiClient from './pythonBaseApi';

const basePath = '/mantenimientos/parametros-generales';

export const parametroGeneralApi = {
  listar: (buscar) =>
    pythonApiClient.get(basePath, { params: buscar ? { buscar } : {} }),

  obtener: (id) => pythonApiClient.get(`${basePath}/${id}`),

  crear: (data) => pythonApiClient.post(basePath, data),

  actualizar: (id, data) => pythonApiClient.put(`${basePath}/${id}`, data),

  eliminar: (id) => pythonApiClient.delete(`${basePath}/${id}`),
};

export default parametroGeneralApi;
